export default "__VITE_ASSET__RrwsN$Ic__"